import axiosInstance from "./global";
import CONFIG from "../../config";
import { stateAndLGA } from "components/tabs/kyc/manageKYC/data/stateAndLGData";
import { stateAndCity } from "components/tabs/kyc/manageKYC/data/stateAndCityData";
import { countries } from "components/tabs/kyc/manageKYC/data/countries";
const baseURL = `${CONFIG.API_BASE_URL}/wayapay-identity-manager/api/v1/waya-merchant/business-kyc`;
const fileUploadUrl = `${CONFIG.WAYABANK_URL}/file-resource-service/upload/others`;

export const getBusinessType = async () => {
  return await axiosInstance
    .get(`${baseURL}/business-industry`)
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      throw new Error("cannot fetch data");
    });
};

// export const getKycList = async (q) => {
//   console.log(q)
//   const params = new URLSearchParams(q).toString();
//   return await axiosInstance
//     // .get(`${baseURL}?${params}`)
//     .get(`${baseURL}`)
//     .then((res) => {
//       return res.data.data;
//     })
//     .catch((err) => console.log(err));
// };

export const getKycList = async (params) => {
  const res = await axiosInstance.get(baseURL, { params });
  return res.data.data; // ⬅ returns { content, totalElements, ... }
};


// export const getKycById = async ({ merchantId }) => {
//   return await axiosInstance
//     .get(`${baseURL}/${merchantId}`)
//     .then((res) => {
//       return res.data.data;
//     })
//     .catch((err) => console.log(err));
// };

// export const getKycById = async ({ merchantId }) => {
//   try {
//     const res = await axiosInstance.get(`${baseURL}/${merchantId}`);
//     console.log("API response:", res.data.data);  
//     return res.data.data;
//   } catch (err) {
//     console.error("Error fetching KYC:", err);
//     return null; // ensures you return null on error
//   }
// };

export const getKycById = async ({ merchantId }) => {
  try {
    const res = await axiosInstance.get(`${baseURL}/${merchantId}`);
    console.log("API response:", res.data.data);  
    return res.data.data;
  } catch (err) {
    console.error("getKycById error:", err);
    throw err; 
  }
};



export const getDirectorKYC = async ({ merchantId }) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/fetchDirectorKyc`, {
    params: {
      merchantId,
    },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching Director KYC:", error);
    throw error;
  }
  };

export const fetchMenuItemByName = async (name, selected) => {
  const { selState, selCity } = selected;
  switch (name) {
    case "businessIndustry":
      return getBusinessType()
        .then((businessTypeList) => {
          return businessTypeList.map(({ name }) => name);
        })
        .catch((err) => ["cannot fetch data"]);
    case "country":
      return new Promise(function (resolve, reject) {
        resolve(countries.map(({ name }) => name));
      });
    case "state":
      return new Promise(function (resolve, reject) {
        resolve(stateAndLGA.map(({ state }) => state));
      });
    case "city":
      return new Promise(function (resolve, reject) {
        if (selState) {
          const itemObj = stateAndCity.find(({ state }) => state === selState);
          resolve(itemObj?.city ?? []);
        } else {
          resolve(["select a state"]);
        }
      });
    case "lga":
      return new Promise(function (resolve, reject) {
        if (selState && selCity) {
          const itemObj = stateAndLGA.find(({ state }) => state === selState);
          resolve(itemObj?.lgas ?? []);
        }
        resolve(["select both state and city"]);
      });
    default:
      break;
  }
};

export const uploadDocument = async ({ filename, file, userId }) => {
  const formData = new FormData();
  formData.append("fileName", filename);
  formData.append("file", file);
  formData.append("userId", 41);

  try {
    const data = await axiosInstance.post(`${fileUploadUrl}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return console.log("successful");
  } catch (err) {
    return console.log("err uploading file");
  }
};

export const uploadWithoutFile = async (data) => {
  const { businessIndustry } = data;
  return await getBusinessType()
    .then((businessTypeList) => {
      const found = businessTypeList.find(
        ({ name }) => name === businessIndustry
      );
      const { id } = found;
      return { ...data, businessIndustry: id };
    })
    .then((data) =>
      axiosInstance
        .post(`${baseURL}`, data)
        .then((res) => res.data)
        .catch((err) => {
          throw new Error("Error updating data");
        })
    );
};

export const approveRejectKYC = async ({
  merchantId,
  status,
  reasonForRejection,
}) => {
  try {
    const data = await axiosInstance.post(
      status === "REJECTED"
        ? `${baseURL}/${merchantId}/change-status/${status}?reasonForRejection=${reasonForRejection}`
        : `${baseURL}/${merchantId}/change-status/${status}`
    );
    return data;
  } catch (err) {
    throw new Error();
  }
};

export const uploadDocx = async (updatedChanges, userId) => {
  const { BUSINESS_CERTIFICATE, BUSINESS_ADDRESS_PROVE, ID_CARD, DIRECTOR_PHOTOGRAPH, ACCOUNT_HOLDER_PHOTOGRAPH } =
    updatedChanges || {};
  const uploadable = [
    {
      filename: "BUSINESS_CERTIFICATE",
      file: BUSINESS_CERTIFICATE,
    },
    {
      filename: "BUSINESS_ADDRESS_PROVE",
      file: BUSINESS_ADDRESS_PROVE,
    },
    { filename: "ID_CARD", file: ID_CARD },
    {
      filename: "DIRECTOR_PHOTOGRAPH",
      file: DIRECTOR_PHOTOGRAPH,
    },
    {
      filename: "ACCOUNT_HOLDER_PHOTOGRAPH",
      file: ACCOUNT_HOLDER_PHOTOGRAPH,
    },
  ];
  const res = uploadable.map(
    ({ filename, file }) =>
      Boolean(file) && uploadDocument({ filename, file, userId })
  );
  return Promise.all(res);
};

export const updateBusinessIndustry = async (q) => {
  const params = new URLSearchParams(q).toString();
  return await axiosInstance
    .patch(`${baseURL}/business-industry?${params}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

export const deleteBusinessIndustry = async ({ businessIndustryId }) => {
  return await axiosInstance
    .delete(`${baseURL}/business-industry/${businessIndustryId}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw new Error(err);
    });
};

export const createBusinessIndustry = async (q) => {
  const params = new URLSearchParams(q).toString();
  return await axiosInstance
    .post(`${baseURL}/business-industry?${params}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};


export const updateMerchantKYC = async (merchantId, payload) => {
  try {

    const isFormData = payload instanceof FormData;

    const res = await axiosInstance.patch(
      `${baseURL}/merchant-kyc/${merchantId}`,
      payload,
      {
        headers: {
          "Content-Type": isFormData
            ? "multipart/form-data"
            : "application/json",
        },
      }
    );

    return res.data;

  } catch (error) {
    console.error("Update Merchant KYC Error:", error);
    throw error;
  }
};
